'use client';

import { useEffect, useRef } from 'react';

import { Input } from '@personly/libs-widgets';
import { useValidators } from '@personly/libs-providers';

import { useEmails } from '@/providers/emails';

interface Props {
  id: string;
  placeholder: string;
  enableInvalid?: boolean;
}

const LoginEmail = ({ id, placeholder, enableInvalid = true }: Props) => {
  const { email, setEmail } = useEmails();
  const emailRef = useRef<HTMLInputElement>(null);
  const { validate } = useValidators();

  useEffect(() => {
    if (emailRef && emailRef.current) emailRef.current.focus();
  }, []);

  return (
    <Input
      ref={emailRef}
      type="email"
      placeholder={placeholder}
      name="username"
      id={id}
      value={email}
      invalid={enableInvalid && email.length > 0 && !validate('EMAIL', email)}
      onChange={(e) => setEmail(e.target.value)}
    />
  );
};

export default LoginEmail;
